module.exports = __webpack_public_path__ + "img/20200512_162351.ed8752f7.jpg";